
/* User defined models */
export class AppointmentSearch {
    confirmationNumber?: string;
    lastName?: string;
  bookingId?: string;

  constructor(confirmationNumber?: string, lastName?: string, bookingId?: string) {
    this.confirmationNumber = confirmationNumber;
    this.lastName = lastName;
    this.bookingId = bookingId
  }
}